import axiosInstance from '../../../config/axiosInstance';
const JobPartsService = {
    async GetJobParts(redirectCallback, IssueID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/GetIssueStock?IssueID=${IssueID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteJobPart(redirectCallback, ID) {
        try {
            const response = await axiosInstance.get(`/Job/DeleteIssueStock?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async UpdatePendingParts(redirectCallback, IssueID) {
        try {
            const response = await axiosInstance.get(`/Job/UpdatePendingParts?IssueID=${IssueID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async AddStockLocation(redirectCallback, IssueStockID, StockLocationID) {
        try {
            const response = await axiosInstance.get(`/Job/AddStockLocation?IssueStockID=${IssueStockID}&StockLocationID=${StockLocationID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllIssueStock(IssueID, Start, PageSize, searchQuery, sortColumn, sortDirection, EmailingName = "", SearchColumns, AssignTo) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Job/GetAllIssueStock?IssueID=${IssueID}&ClientID=${ClientID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}&AssignTo=${AssignTo}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async JobsPartCount(IssueID, searchQuery, SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Job/JobsPartCount?IssueID=${IssueID}&searchQuery=${searchQuery}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
};

export default JobPartsService;